import React from 'react';
import PropTypes from 'prop-types';

import { StyledVdpBox, Divider } from './Styles';

const propTypes = {
  children: PropTypes.node
};

const defaultProps = {
  children: undefined
};

const VdpBox = ({ className, children, id }) => {
  return (
    <>
      <Divider id="styled-divider" />
      <StyledVdpBox className={className} id={id}>
        {children}
      </StyledVdpBox>
    </>
  );
};

VdpBox.propTypes = propTypes;
VdpBox.defaultProps = defaultProps;

export default VdpBox;
